// API 주소 자동 설정
// 우선순위:
//   1. REACT_APP_API_BASE (Phase 2.3 도메인 분리 후 https://api.autodex.kr)
//   2. production: window.location.origin (Phase 2.3 이전 단일 도메인 운영 — 폴백)
//   3. development: http://localhost:4000
var _envBase = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');
var _runtimeBase = process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost:4000';
var API_ORIGIN = _envBase || _runtimeBase;
var API = API_ORIGIN + '/api';

// 업체 계정이면 companyId 쿼리 파라미터 추가하는 헬퍼
var carsUrl = function(user) {
  if (user && user.role === '업체' && user.companyId > 0) {
    return API + '/cars?companyId=' + user.companyId;
  }
  return API + '/cars';
};

// JWT 토큰 관리
var getToken = function() {
  return localStorage.getItem('autodoc_token') || '';
};

// 인증 헤더 포함 fetch (점진적 적용용)
var authFetch = function(url, options) {
  options = options || {};
  options.headers = options.headers || {};
  var token = getToken();
  if (token) {
    options.headers['Authorization'] = 'Bearer ' + token;
  }
  if (!options.headers['Content-Type'] && !(options.body instanceof FormData)) {
    options.headers['Content-Type'] = 'application/json';
  }
  return fetch(url, options);
};

export { API, API_ORIGIN, carsUrl, getToken, authFetch };
export default API;
